import { ActionTypes } from '../constants/ActionTypes';

export function setEvents(events) {
  return {
    type: ActionTypes.SET_EVENTS,
    events
  };
};

export function getIssues(issues) {
  return {
    type: ActionTypes.GET_ISSUES,
    issues
  };
};

export function getIssuesMap(issuesMap) {
  return {
    type: ActionTypes.GET_ISSUES_MAP,
    issuesMap
  };
};

export function setEvent(event) {
  return {
    type: ActionTypes.SET_EVENT,
    event
  };
};

export function saveEvent(events) {
  return {
    type: ActionTypes.SAVE_EVENT,
    events
  };
};

export function removeIssueToMap(issue) {
    return {
        type: ActionTypes.REMOVE_ISSUE_TO_MAP,
        issue
    };
};

export function saveEventMap(issue) {
  return {
    type: ActionTypes.SAVE_EVENT_MAP,
    issue
  };
};

export function getTrackersMap(trackers) {
  return {
    type: ActionTypes.GET_TRACKERS_MAP,
    trackers
  };
};

export function pushIssues() {
  return {
    type: ActionTypes.SET_PUSH_ISSUES,
  };
};

export function saveNewEvent(events) {
  return {
    type: ActionTypes.SAVE_NEW_EVENT,
    events
  };
};

export function saveNewEventMap(issue) {
  return {
    type: ActionTypes.SAVE_NEW_EVENT_MAP,
    issue
  };
};


// WEBPACK FOOTER //
// ./src/actions/events.js